import React, {Component} from 'react';
import {List, ListItem} from 'material-ui/List';
import {Link} from 'react-router';
import Paper from 'material-ui/Paper';
import ContentInbox from 'material-ui/svg-icons/content/inbox';
import Assignees from '../images/Assignees.svg';
import Overview from '../images/Overview.svg';
import AddItems from '../images/T-ShirtAdd.svg';
import CurrentItems from '../images/T-Shirts.svg';
import Graph from '../images/Graph.svg';
import Require from '../components/Require';
import SvgIcon from 'material-ui/SvgIcon'
const SmallDiv = (props) => {
    return (<Paper style={{zIndex: 4, width: 64, position: 'fixed', top: 64, bottom: 0}} zDepth={1}
                   rounded={false}>{props.children}</Paper>);
}

const BigDiv = (props) => {
    return (<Paper style={{zIndex: 4, width: 190, position: 'fixed', top: 64, bottom: 0}} zDepth={1}
                   rounded={false}>{props.children}</Paper>);
}

class NavMenu extends Component {

    static defaultProps() {
        return {
            mode: 'BIG',
            open: true
        };
    }


    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(event) {

    }
    getRootComponent() {
        const mode = this.props.mode;
        if (mode === 'BIG') {
            return BigDiv;
        }
        return SmallDiv;
    }

    render() {
        const styles = {
            height: 48,
        };
        const             innerDivStyle=  {
            paddingLeft: 57

        };

        const props = this.props;
        const Holder = this.getRootComponent();
        const showText = props.mode == 'BIG';
        const open = props.open;
        return (<Holder onRequestChange={props.onMenuToggle} docked={false} open={open} props={props}
                        style={{overflow: 'hidden'}}>
            <List>
                <Require initialized={true} permission="pm:work-sessions:list">
                    <Link className='nav-menu__link' activeClassName='nav-menu__link--active' to="/work-sessions">
                        <ListItem primaryText={showText ? "Work Sessions" : null}
                                  style={styles}
                                  innerDivStyle={innerDivStyle}
                                  leftIcon={<ContentInbox />}/>
                    </Link>
                </Require>
                <Require active={true} permission="pm:assignees:list">
                    <Link className='nav-menu__link' activeClassName='nav-menu__link--active' to="/assignees">
                        <ListItem primaryText={showText ? "Assignees" : null}
                                  style={styles}
                                  innerDivStyle={innerDivStyle}
                                  leftIcon={<SvgIcon viewBox="0 0 24 24"><Assignees/></SvgIcon>}/>
                    </Link>
                </Require>
                <Require active={true} permission="pm:add-items:list">
                    <Link className='nav-menu__link' activeClassName='nav-menu__link--active' to="/add-items">
                        <ListItem primaryText={showText ? "Add Items" : null}
                                  style={styles}
                                  innerDivStyle={innerDivStyle}
                                  leftIcon={<SvgIcon viewBox="0 0 24 24"><AddItems/></SvgIcon>}/>
                    </Link>
                </Require>
                <Require active={true} permission="pm:current-items:list">
                    <Link className='nav-menu__link' activeClassName='nav-menu__link--active' to="/current-items">
                        <ListItem primaryText={showText ? "Current Items" : null}
                                  style={styles}
                                  innerDivStyle={innerDivStyle}
                                  leftIcon={<SvgIcon viewBox="0 0 24 24"><CurrentItems/></SvgIcon>}/>
                    </Link>
                </Require>
                <Require active={true} permission="pm:overview:list">
                    <Link className='nav-menu__link' activeClassName='nav-menu__link--active' to="/overview">
                        <ListItem primaryText={showText ? "Overview" : null}
                                  style={styles}
                                  innerDivStyle={innerDivStyle}
                                  leftIcon={<SvgIcon viewBox="0 0 24 24"><Overview/></SvgIcon>}/>
                    </Link>
                </Require>
                <Require active={true} permission="pm:statistics:list">
                    <Link className='nav-menu__link' activeClassName='nav-menu__link--active' to="/statistics">
                        <ListItem primaryText={showText ? "Statistics" : null}
                                  style={styles}
                                  innerDivStyle={innerDivStyle}
                                  leftIcon={<SvgIcon viewBox="0 0 24 24"><Graph/></SvgIcon>}/>
                    </Link>
                </Require>
            </List>
        </Holder>)

    }
}
NavMenu.propTypes = {
    mode: React.PropTypes.oneOf(['DRAWER', 'SMALL', 'BIG']).isRequired,
    open: React.PropTypes.bool.isRequired
};
export default NavMenu;


// WEBPACK FOOTER //
// ./src/ui/components/NavMenu.js